import React from 'react'
import { PageHeader, SurfaceCard } from '../../Components/Ui'
import EventForm from './EventForm'

const Event = () => {
    return <>
        <PageHeader
            eyebrow="Super Papelera — Espacio de trabajo"
            title="Nuevo Evento"
            subtitle="Completa el formulario para publicar un nuevo evento."
        />
        <SurfaceCard>
            <EventForm />
        </SurfaceCard>
    </>
}

export default Event
